import { IHeaderType } from "../../../types/types";
import SectionHeader from "../../../utils/section-header";



type Props = {
};

const RowOne = (props: Props) => {

  return (
    <>
      <SectionHeader
        titleText={"Our signature accomplishments"}
        descText={"Explore breakthrough solutions crafted to transform businesses. Case studies of visionary strategies and impactful results. Inspiration for your next big leap."}
        type={IHeaderType.h2}
      />
    </>
  );
};

export default RowOne;
